import {
  PlanData,
  WarehouseInfos as WarehouseResource,
} from "models/PlanInfos";

export type WarehouseResponse = {
  magNum: number;
  plan: PlanData;
};

export function transformWarehouseResponseToResource(
  warehouseResponse: WarehouseResponse
): WarehouseResource {
  return new WarehouseResource().deserialize(warehouseResponse);
}
